<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="_1-CN ParaOverride-6" id="_idParaDest-6"><span class="leading-139-5 CharOverride-11">W</span><span class="CharOverride-11">hat is honour? A word. What is in that word ‘honour’? What is that ‘honour’? Air . . .</span></p>
<p class="EPG2_Epigraph_text_2_Full-out">William Shakespeare, <br/><span class="EPG2_Epigraph_text_2_Italic _idGenCharOverride-1">Henry IV Part I</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBookVR02455.vue?7c452b78